import { useAnalysisStore } from '@modules/analysis/store/analysisStore';
import { DEFAULT_QUANTIFY_TOP_SELECTION_VALUE } from '@modules/quantify/constants';
import { useFetchQuantifyReport } from '@modules/quantify/hooks';
import { QuantifyActionType } from '@modules/quantify/store/quantifyActionType';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { isTopSelectionSupported } from '@modules/quantify/utils';
import { Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { createAnalyticsTracker } from 'v2/analytics/events';
import { shallow } from 'zustand/shallow';

const trackQuantifyReportEvents = createAnalyticsTracker('quantifyReport');

export const QuantifyResetToTopSelectionButton = () => {
  const dispatch = useQuantifyStore((state) => state.dispatch);
  const fetchQuantifyReportData = useFetchQuantifyReport();
  const [shouldFetchReportData, setShouldFetchReportData] = useState(false);
  const { activeVisualisationType, groupByLabel, shouldShowTopDataPoints } =
    useQuantifyStore(({ metadata, query }) => {
      return {
        activeVisualisationType: metadata.activeVisualisationType,
        groupByLabel: query.groupBy?.displayName ?? '',
        shouldShowTopDataPoints: metadata.shouldShowTopDataPoints,
      };
    }, shallow);

  const { title: name, href } = useAnalysisStore(
    ({ title, href, scope }) => ({ title, href, scope }),
    shallow,
  );

  useEffect(() => {
    if (shouldFetchReportData) {
      setShouldFetchReportData(false);
      fetchQuantifyReportData();
    }
  }, [shouldFetchReportData, fetchQuantifyReportData]);

  const isShowTopSelectionEnabled = isTopSelectionSupported(
    activeVisualisationType,
  );
  const shouldShowResetToTopSelectionButton =
    isShowTopSelectionEnabled && !shouldShowTopDataPoints;

  const onReset = () => {
    dispatch({
      type: QuantifyActionType.SET_METADATA,
      payload: {
        shouldShowTopDataPoints: true,
        visibleDataPoints: [],
        topDataPointsSelectionCount: DEFAULT_QUANTIFY_TOP_SELECTION_VALUE,
      },
    });

    setShouldFetchReportData(true);

    trackQuantifyReportEvents({
      eventName: 'Quantify Report - Reset To Top X Values',
      name,
      link: href,
      query: {
        showMeLabel: groupByLabel,
      },
    });
  };

  if (!shouldShowResetToTopSelectionButton) {
    return null;
  }

  return (
    <Button size="small" onClick={onReset}>
      Reset To Top Values
    </Button>
  );
};
